module.exports = __webpack_public_path__ + "img/video_interativo_gravacao.13fd38c2.jpg";